import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';
import { pdf } from '@react-pdf/renderer';
import ExportPDFCSafetyAgreementFormFDWEmployer from './ExportPDFCSafetyAgreementFormFDWEmployer';

// eslint-disable-next-line react/prop-types
const CSafetyAgreementFormFDWEmployer = ({ booking_id }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    // Part A - Employer
    employerName: '',
    employerNric: '',
    dwelling: '',
    cleanExterior: '',
    location: [],
    grilles: '',
    supervision: '',
    empDecl: '',
    empSignature: '',
    
    // Part B - Employment Agency Personnel
    eapName: '',
    eapReg: '',
    eapDecl: '',
    eapSignature: '',
    
    // Part C - Migrant Domestic Worker
    mdwName: '',
    mdwWp: '',
    mdwDecl: '',
    mdwSignature: '',
    
    // Part D - Employment Agency Personnel (Second)
    eapDecl2: '',
    eapSignature2: ''
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name === 'location') {
        setFormData(prev => ({
          ...prev,
          location: checked 
            ? [...(prev.location || []), value]
            : (prev.location || []).filter(item => item !== value)
        }));
      }
    } else if (type === 'radio') {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
const [agencyInfo, setAgencyInfo] = useState({});
  // Fetch existing safety agreement data
  const fetchSafetyAgreementData = async () => {
    if (!booking_id) return;
    
    setIsLoading(true);
    try {
      const response = await api.get(`external-forms/safety-agreement-c-fdw-employer/${booking_id}/`);
      if (response.data) {
          setAgencyInfo({
          agencyAddress: response.data.agency_address || '',
          agencyPhone: response.data.agency_phone || ''
        });
        setFormData({
          employerName: response.data.employer_name || '',
          employerNric: response.data.employer_nric || '',
          dwelling: response.data.dwelling || '',
          cleanExterior: response.data.clean_exterior || '',
          location: response.data.location ? JSON.parse(response.data.location) : [],
          grilles: response.data.grilles || '',
          supervision: response.data.supervision || '',
          empDecl: response.data.emp_decl || '',
          empSignature: response.data.emp_signature || '',
          eapName: response.data.eap_name || '',
          eapReg: response.data.eap_reg || '',
          eapDecl: response.data.eap_decl || '',
          eapSignature: response.data.eap_signature || '',
          mdwName: response.data.mdw_name || '',
          mdwWp: response.data.mdw_wp || '',
          mdwDecl: response.data.mdw_decl || '',
          mdwSignature: response.data.mdw_signature || '',
          eapDecl2: response.data.eap_decl2 || '',
          eapSignature2: response.data.eap_signature2 || ''
        });
      }
    } catch (error) {
      console.error('Error fetching safety agreement data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSafetyAgreementData();
  }, [booking_id]);

  const validateForm = () => {
    const newErrors = {};
    // Add validation rules here if needed
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      const submitData = {
        booking: booking_id,
        employer_name: formData.employerName,
        employer_nric: formData.employerNric,
        dwelling: formData.dwelling,
        clean_exterior: formData.cleanExterior,
        location: JSON.stringify(formData.location),
        grilles: formData.grilles,
        supervision: formData.supervision,
        emp_decl: formData.empDecl,
        emp_signature: formData.empSignature,
        eap_name: formData.eapName,
        eap_reg: formData.eapReg,
        eap_decl: formData.eapDecl,
        eap_signature: formData.eapSignature,
        mdw_name: formData.mdwName,
        mdw_wp: formData.mdwWp,
        mdw_decl: formData.mdwDecl,
        mdw_signature: formData.mdwSignature,
        eap_decl2: formData.eapDecl2,
        eap_signature2: formData.eapSignature2
      };

      const response = await api.post(`external-forms/safety-agreement-c-fdw-employer/${booking_id}/`, submitData);
      console.log('Safety agreement submitted successfully:', response.data);
      alert('Safety agreement form submitted successfully!');
      
    } catch (error) {
      console.error('Error submitting safety agreement:', error);
      if (error.response?.data) {
        if (typeof error.response.data === 'object') {
          setErrors(error.response.data);
        } else {
          alert('Error submitting form: ' + error.response.data);
        }
      } else {
        alert('Error submitting form. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const originalHandleSubmit = (e) => {
    e.preventDefault();
    console.log('Safety Agreement Form Data:', formData);
    // Handle form submission here
  };

  const handleReset = () => {
    setFormData({
      employerName: '',
      employerNric: '',
      dwelling: '',
      cleanExterior: '',
      location: [],
      grilles: '',
      supervision: '',
      empDecl: '',
      empSignature: '',
      eapName: '',
      eapReg: '',
      eapDecl: '',
      eapSignature: '',
      mdwName: '',
      mdwWp: '',
      mdwDecl: '',
      mdwSignature: '',
      eapDecl2: '',
      eapSignature2: ''
    });
  };

  const handleDelete = async () => {
    if (!booking_id) {
      alert('No booking ID provided for deletion');
      return;
    }

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this C Safety Agreement record? This action cannot be undone.'
    );

    if (!confirmDelete) {
      return;
    }

    setIsSubmitting(true);

    try {
      console.log('Deleting C Safety Agreement for booking_id:', booking_id);
      const response = await api.delete(`external-forms/safety-agreement-c-fdw-employer/${booking_id}/`);
      console.log('C Safety Agreement deleted successfully:', response.data);
      
      // Show success message
      alert('C Safety Agreement record deleted successfully!');
      
      // Reset the form after deletion
      handleReset();
      
    } catch (error) {
      console.error('Error deleting C Safety Agreement:', error);
      alert('C Safety Agreement record deleted successfully');
    } finally {
      setIsSubmitting(false);
    }
  };

  const { user } = useAuth();

  const handleDownloadPDF = async () => {
    try {
    
      const doc = (
        <ExportPDFCSafetyAgreementFormFDWEmployer 
          formData={formData} 
         user={user}
         agencyInfo={agencyInfo}
        />
      );
      
      const asPdf = pdf(doc);
      const blob = await asPdf.toBlob();
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      const currentDate = new Date().toISOString().split('T')[0];
      link.download = `c-safety-agreement-${booking_id || 'draft'}-${currentDate}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  };

  return (
    <>
      
      <div className="page-wrapper" style={{ marginLeft: '0' }}>
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="content-page-header">
                    <h5>Safety Agreement Between Migrant Domestic Worker and Employer</h5>
                  </div>

                  {/* Loading Indicator */}
                  {isLoading && (
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <div className="spinner-border text-primary me-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">Loading existing safety agreement data...</span>
                    </div>
                  )}

                  {/* Form Content - Hidden during loading */}
                  <div style={{ display: isLoading ? 'none' : 'block' }}>
                  <form onSubmit={handleSubmit}>
                    {/* Part A - Employer */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Part A – Employer</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Name of Employer</label>
                              <input
                                type="text"
                                name="employerName"
                                value={formData.employerName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>NRIC / FIN (last 4 chars)</label>
                              <input
                                type="text"
                                name="employerNric"
                                value={formData.employerNric}
                                onChange={handleInputChange}
                                className="form-control"
                                maxLength="4"
                              />
                            </div>
                          </div>
                        </div>

                        <label className="mb-2">Residential Dwelling Type</label>
                        <div className="row">
                          {[
                            { value: 'HDB', label: 'HDB Apartment' },
                            { value: 'Private', label: 'Private Apartment / Condo' },
                            { value: 'Landed', label: 'Landed Property' }
                          ].map((dwelling) => (
                            <div key={dwelling.value} className="col-lg-4 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="dwelling"
                                  value={dwelling.value}
                                  checked={formData.dwelling === dwelling.value}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`dwelling-${dwelling.value}`}
                                />
                                <label className="form-check-label" htmlFor={`dwelling-${dwelling.value}`}>
                                  {dwelling.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <label className="mb-2">Require MDW to clean window exterior?</label>
                        <div className="row">
                          {['Yes', 'No'].map((option) => (
                            <div key={option} className="col-lg-6 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="cleanExterior"
                                  value={option}
                                  checked={formData.cleanExterior === option}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`clean-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`clean-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <label className="mb-2">Location of window exterior</label>
                        <div className="row">
                          {[
                            { value: 'Ground', label: 'On the ground' },
                            { value: 'Corridor', label: 'Facing common corridor' },
                            { value: 'Others', label: 'Others' }
                          ].map((location) => (
                            <div key={location.value} className="col-lg-4 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="checkbox"
                                  name="location"
                                  value={location.value}
                                  checked={(formData.location || []).includes(location.value)}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`location-${location.value}`}
                                />
                                <label className="form-check-label" htmlFor={`location-${location.value}`}>
                                  {location.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <label className="mb-2">Grilles installed on required windows?</label>
                        <div className="row">
                          {['Yes', 'No'].map((option) => (
                            <div key={option} className="col-lg-6 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="grilles"
                                  value={option}
                                  checked={formData.grilles === option}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`grilles-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`grilles-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <label className="mb-2">Adult supervision when cleaning?</label>
                        <div className="row">
                          {['Yes', 'No'].map((option) => (
                            <div key={option} className="col-lg-6 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="supervision"
                                  value={option}
                                  checked={formData.supervision === option}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`supervision-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`supervision-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <label className="mb-2">Employer Declaration (choose one)</label>
                        <div className="row">
                          {[
                            { value: 'Not required', label: 'I will not require my MDW to clean exterior' },
                            { value: 'Ground', label: 'Require only ground floor exterior' },
                            { value: 'Corridor', label: 'Require only corridor exterior' },
                            { value: 'Supervised', label: 'Require with locked grilles + supervision' }
                          ].map((declaration) => (
                            <div key={declaration.value} className="col-lg-6 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="empDecl"
                                  value={declaration.value}
                                  checked={formData.empDecl === declaration.value}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`empDecl-${declaration.value}`}
                                />
                                <label className="form-check-label" htmlFor={`empDecl-${declaration.value}`}>
                                  {declaration.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="input-block mb-3">
                          <label>Signature / Date</label>
                          <input
                            type="text"
                            name="empSignature"
                            value={formData.empSignature}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Type name and date as signature"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Part B - Employment Agency Personnel */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Part B – Employment Agency Personnel</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Name of EAP / KAH</label>
                              <input
                                type="text"
                                name="eapName"
                                value={formData.eapName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Registration Number</label>
                              <input
                                type="text"
                                name="eapReg"
                                value={formData.eapReg}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="input-block mb-3">
                          <label>Declaration</label>
                          <textarea
                            name="eapDecl"
                            value={formData.eapDecl}
                            onChange={handleInputChange}
                            className="form-control"
                            rows="3"
                            placeholder="Can / cannot require MDW to clean based on Part A"
                          />
                        </div>

                        <div className="input-block mb-3">
                          <label>Signature / Date</label>
                          <input
                            type="text"
                            name="eapSignature"
                            value={formData.eapSignature}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Type name and date as signature"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Part C - Migrant Domestic Worker */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Part C – Migrant Domestic Worker</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Name of MDW</label>
                              <input
                                type="text"
                                name="mdwName"
                                value={formData.mdwName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Work Permit No (last 4 digits)</label>
                              <input
                                type="text"
                                name="mdwWp"
                                value={formData.mdwWp}
                                onChange={handleInputChange}
                                className="form-control"
                                maxLength="4"
                              />
                            </div>
                          </div>
                        </div>

                        <label className="mb-2">MDW Declaration (choose one)</label>
                        <div className="row">
                          {[
                            { value: 'Not required', label: 'Not required to clean window exterior' },
                            { value: 'Ground', label: 'Required only for ground floor exterior' },
                            { value: 'Corridor', label: 'Required only for corridor exterior' },
                            { value: 'Supervised', label: 'Required with locked grilles + supervision' }
                          ].map((declaration) => (
                            <div key={declaration.value} className="col-lg-6 col-12">
                              <div className="form-check mb-3">
                                <input
                                  type="radio"
                                  name="mdwDecl"
                                  value={declaration.value}
                                  checked={formData.mdwDecl === declaration.value}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`mdwDecl-${declaration.value}`}
                                />
                                <label className="form-check-label" htmlFor={`mdwDecl-${declaration.value}`}>
                                  {declaration.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="input-block mb-3">
                          <label>Signature / Date</label>
                          <input
                            type="text"
                            name="mdwSignature"
                            value={formData.mdwSignature}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Type name and date as signature"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Part D - Employment Agency Personnel (Second) */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Part D – Employment Agency Personnel</h6>
                      </div>
                      <div className="card-body">
                        <div className="input-block mb-3">
                          <label>Declaration</label>
                          <textarea
                            name="eapDecl2"
                            value={formData.eapDecl2}
                            onChange={handleInputChange}
                            className="form-control"
                            rows="3"
                            placeholder="Can / cannot clean based on employer's Part A"
                          />
                        </div>

                        <div className="input-block mb-3">
                          <label>Signature / Date</label>
                          <input
                            type="text"
                            name="eapSignature2"
                            value={formData.eapSignature2}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Type name and date as signature"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Form Buttons */}
                    <div className="row">
                      <div className="col-12">
                        <div className="btn-path text-end">
                          <button
                            type="button"
                            onClick={handleReset}
                            className="btn btn-cancel bg-primary-light me-3"
                            disabled={isSubmitting}
                          >
                            Reset
                          </button>
                          <button
                            type="button"
                            onClick={handleDelete}
                            className="btn btn-danger me-3"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Deleting...' : 'Clean'}
                          </button>
                          <button
                            type="button"
                            onClick={handleDownloadPDF}
                             className="btn btn-success me-3"
                            disabled={isSubmitting}
                          >
                            <i className="fe fe-download me-1"></i>
                            Download PDF
                          </button>
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                    {errors.general && (
                      <div className="alert alert-danger mt-3">{errors.general}</div>
                    )}
                  </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CSafetyAgreementFormFDWEmployer;